module.exports = __webpack_public_path__ + "static/media/grouped_items.2d7ae8bb.png";